import React from "react";
import { Formik, Form, FormikHelpers } from "formik";
import LoginForm from "./LoginForm";
import { object, string } from "yup";
import { useNavigate } from "react-router-dom";
import { showToast } from "src/utils/showToaster";
import { AppDispatch } from "src/redux/store";
import { useDispatch } from "react-redux";
import { setAccessToken, setUserType } from "src/redux/slices/AuthSlice";
import { useLoginMutation } from "src/services/AuthServices";
import {
  authTokenKeyName,
  refreshTokenKeyName,
} from "src/utils/configs/authConfig";

export type LoginFormInitialValues = {
  userName: string;
  password: string;
};

const LoginFormWrapper = () => {
  const dispatch = useDispatch<AppDispatch>();

  const afterLogin = (res: any) => {
    localStorage.setItem(authTokenKeyName, res?.token);
    localStorage.setItem(refreshTokenKeyName, res?.refreshToken);
    localStorage.setItem("userType", res?.userType);
    localStorage.setItem("deviceId", res?.deviceId);
    localStorage.setItem(
      "userData",
      JSON.stringify({
        name: res?.fullName,
        mobile: res?.mobile,
        userName: res?.userName,
        userRole: res?.userRole,
        userId: res?.userId,
      })
    );
    dispatch(setAccessToken(res?.accessToken));

    dispatch(setUserType(res?.userType));
  };
  const navigate = useNavigate();
  const [login] = useLoginMutation();
  const initialValues: LoginFormInitialValues = {
    userName: "",
    password: "",
  };

  const validationSchema = object({
    userName: string().required("Please enter user name"),
    password: string().required("Password is required"),
  });

  const handleSubmit = (
    values: LoginFormInitialValues,
    { setSubmitting }: FormikHelpers<LoginFormInitialValues>
  ) => {
    setSubmitting(true);
    login(values).then((res: any) => {
      setSubmitting(false);
      if (res.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          afterLogin(res?.data?.data);
          navigate("/welcome");
        } else {
          showToast("error", res?.data?.message);
        }
      }
    });
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <LoginForm formikProps={formikProps} />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default LoginFormWrapper;
